module.exports = __webpack_public_path__ + "img/Aubree_Andres.05d6b776.jpeg";